import React, { useCallback, type FC } from 'react';
import { OtpChannel } from '../otp-channel/otp-channel';
import type { OtpChannelSelectorListProps, RenderOtpChannelItemParams } from './otp-channel-selector-list.types';
import { FlatList } from '../flat-list';

import styles from './otp-channel-selector-list.module.css';

export const OtpChannelSelectorList: FC<OtpChannelSelectorListProps> = ({ otpChannels }) => {
    const renderItem = useCallback(({ item }: RenderOtpChannelItemParams) => {
        return <OtpChannel key={item?.name} channel={item} />;
    }, []);

    return (
        <div className={styles.container}>
            <FlatList data={otpChannels} renderItem={renderItem} contentContainerClassName={styles.contentWrapper} />
        </div>
    );
};
